import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';

const DeletePlan = ({ plan, error }) => {
  if (error) {
    return (
      <Alert severity='error'>
        <Translate id='transactions.dialogs.forceStop.planError' />
      </Alert>
    );
  }
  if (plan === null) {
    return <LinearProgress />;
  }
  return (
    <>
      {plan.hasMeters && (
        <Alert severity='warning' style={{ marginBottom: 8 }}>
          <Translate id='transactions.dialogs.forceStop.hasMeters' />
        </Alert>
      )}
      {plan.amount > 0 ? (
        <Alert severity='info'>
          <Translate
            id='transactions.dialogs.forceStop.unlockBudget'
            data={{ amount: plan.amount, rfid: plan.rfid.split('__')[1], oldLocked: plan.oldLocked, newLocked: plan.newLocked }}
          />
        </Alert>
      ) : (
        <Alert severity='info'>
          <Translate id='transactions.dialogs.forceStop.noBudget' />
        </Alert>
      )}
    </>
  );
};

const TransactionsDialogForceStop = (props) => {
  let isDelete = props.mode === 'delete';
  let canSubmit = !props.processing && (isDelete ? props.deletePlan !== null && !props.deletePlanError : props.payload !== null);
  return (
    <Dialog onClose={props.handleClose} aria-labelledby='transaction-running-dialog-forcestop-title' open={props.open} fullWidth maxWidth='sm'>
      <DialogTitle id='transaction-running-dialog-forcestop-title'>
        <Translate id='transactions.dialogs.forceStop.title' />
      </DialogTitle>
      <DialogContent>
        <RadioGroup value={props.mode} onChange={props.changeMode}>
          <FormControlLabel
            value='stop'
            disabled={props.payloadError}
            control={<Radio color='primary' />}
            label={<Translate id='transactions.dialogs.forceStop.modeStop' />}
          />
          <FormControlLabel value='delete' control={<Radio color='primary' />} label={<Translate id='transactions.dialogs.forceStop.modeDelete' />} />
        </RadioGroup>
        {props.payloadError && (
          <Alert severity='warning' style={{ marginBottom: 8 }}>
            <Translate id='transactions.dialogs.forceStop.idTagError' />
          </Alert>
        )}
        {isDelete ? (
          <>
            <Typography gutterBottom>
              <Translate id='transactions.dialogs.forceStop.textDelete' />
            </Typography>
            <DeletePlan plan={props.deletePlan} error={props.deletePlanError} />
          </>
        ) : props.payload === null ? (
          !props.payloadError && <LinearProgress />
        ) : (
          <>
            <Typography gutterBottom>
              <Translate id='transactions.dialogs.forceStop.text' />
            </Typography>
            <Typography component='pre' variant='body2' style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {JSON.stringify(props.payload, null, 2)}
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color='default' autoFocus disabled={props.processing}>
          <Translate id='transactions.dialogs.forceStop.cancel' />
        </Button>
        <Button onClick={props.submit} color='secondary' disabled={!canSubmit}>
          <Translate id={isDelete ? 'transactions.dialogs.forceStop.submitDelete' : 'transactions.dialogs.forceStop.submit'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withLocalize(TransactionsDialogForceStop);
